import events from 'events-bus';
import { useState, useEffect } from 'react';

import {
    AUTH_SUCCESS_EVENT,
    AUTH_LOGOUT_EVENT,
    AUTH_FAILURE_EVENT,
    AUTH_READY,
} from '../utils/constants';

export function useLogin(): [boolean, number, boolean] {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [customerStatusLoaded, setCustomerStatusLoaded] = useState(false);
    const [customerId, setCustomerId] = useState(-1);
    useEffect(() => {
        events.on(AUTH_READY, () => {
            setCustomerStatusLoaded(true);
        });
        events.on(AUTH_SUCCESS_EVENT, (_eventName: any, data: any) => {
            setCustomerId(data.payload.customerId);
            setIsLoggedIn(true);
        });
        events.on(AUTH_LOGOUT_EVENT, () => {
            setIsLoggedIn(false);
            setCustomerId(-1);
        });
        events.on(AUTH_FAILURE_EVENT, () => {
            setIsLoggedIn(false);
            setCustomerStatusLoaded(true);
        });
    }, []);

    return [isLoggedIn, customerId, customerStatusLoaded];
}
